import { RegistrationKind } from '~/domain/patient/approvableRegistration';

export function registrationKindSymbol(kind: RegistrationKind): string {
    return kind === 'deformable' ? 'D' : 'R';
}
